module.exports = __webpack_public_path__ + "static/media/mobile-nav-help-desk.72810de3.svg";